import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showLoader, hideLoader } from '../../../store/common/slice';
import { fetchBuildingData } from '../../../store/buildings/actions';
import { constants } from '../../../common/constants/constants';
import { useAccessToken } from '../../../common/hooks/useAccessToken';
import BllinkUtils from '../../../common/utils/utils';
import { CurrencyValue } from '../../../common/currencyValue';
import manager from '../../../images/newDesign/manager.svg';
import hammer from '../../../images/newDesign/hammer.svg';
import { InfoCardStyled } from '../tenantList/TenantList.styled';
import { shortenText, calcMonthsTextForSelectBox } from '../../../common/shared/statelessMethods';

const StringUtils = BllinkUtils.Strings;

const DebtCard = ({ apt, selectedApt, onClick, num, buildingID, csvCallback, currency }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const client = useAccessToken();
    const ltr = useSelector(state => state.common.ltrEnabled);
    const [isManager, setIsManager] = useState(false);
    const [isMarkedInLegalIssue, setIsMarkedInLegalIssue] = useState(false);
    const [generalDebt, setGeneralDebt] = useState();
    const [monthlyDebt, setMonthlyDebt] = useState();
    const [oneTimeDebt, setOneTimeDebt] = useState();

    const [selected, setSelected] = useState(false);

    useEffect(() => {
        const monthlyValue = apt?.pastPaymentsLeft;
        const oneTimeValue = apt?.oneTimeLeft;
        const debt = StringUtils.numberWithCommas(+oneTimeValue + +monthlyValue);
        setGeneralDebt(debt);

        let monthlyComment = '';
        if (apt?.openMonthDebtPayments) monthlyComment = shortenText(calcMonthsTextForSelectBox(apt?.openMonthDebtPayments));
        setMonthlyDebt({value: monthlyValue, comment: monthlyComment?.originalComment || monthlyComment?.shortComment || monthlyComment});
        let oneTimeComment = '';
        if (apt?.openOneTimePayments?.length) {
            oneTimeComment = apt.openOneTimePayments.reduce((acc, curVal, index) => `${acc} ${curVal.payment_description}${index < apt.openOneTimePayments.length - 1 ? ',' : ''}`, '');
        }
        setOneTimeDebt({value: oneTimeValue, comment: oneTimeComment});
    }, [apt]);

    useEffect(async () => {
        if (!client) return;

        dispatch(showLoader());

        // TODO: define if is manager and is in legal issues by apartment number
        // const isManager = await client.operations.getFeature('apartmentNumber', apt.apartmentNumber, 'buildingManager');
        // if (isManager?.value === 'true' || isManager?.value === true) setIsManager(true);

        // const isInIssues = await client.operations.getFeature('apartmentNumber', apt.apartmentNumber, 'legalIssues');
        // if (isInIssues?.value === 'true' || isInIssues?.value === true) setIsMarkedInLegalIssue(true);

        dispatch(hideLoader());
    }, [client]);

    useEffect(() => {
        if (selectedApt?.apartmentNumber === apt?.apartmentNumber) setSelected(true)
        else setSelected(false)
    }, [selectedApt]);

    useEffect(() => monthlyDebt && oneTimeDebt && generalDebt && csvCallback({
        apartmentNumber: apt?.apartmentNumber,
        tenantName: apt?.tenantName,
        phone: apt?.tenantPhone,
        totalDebt: StringUtils.numberWithCommas(+apt?.pastPaymentsLeft + +apt?.oneTimeLeft),
        monthlyDebt: monthlyDebt?.value,
        monthlyDetails: monthlyDebt?.comment,
        specialDebt: oneTimeDebt?.value,
        specialDetails: oneTimeDebt?.comment,
        monthlyFee: generalDebt
    }), [monthlyDebt, oneTimeDebt, generalDebt]);

    function getDebtType() {
        const monthlyValue = apt?.pastPaymentsLeft;
        const oneTimeValue = apt?.oneTimeLeft;
        if (oneTimeValue > 0 && monthlyValue > 0) {
            return t('reports.monthly_fee_and_spec_payment');
        } else if (oneTimeValue > 0) {
            return t('reports.special_payment');
        } else if (monthlyValue > 0) {
            return t('reports.monthly_fee');
        }
    }

    return (
        <InfoCardStyled selected={selected} onClick={() => onClick(num)} ltr={ltr}>
            <div className='card-title'>
                <span>{t('payments.number_of_apartment')}: {apt?.apartmentNumber}</span>
                <span className='title-icons-wrapper'>
                    {isManager && <img src={manager} />}
                    {isMarkedInLegalIssue && <img src={hammer} />}
                </span>
            </div>

            <div className='cards-body'>
                <div>
                    <div className='inner-title'>{t('reports.debt_type')}</div>
                    <div className='value'>{getDebtType()}</div>
                </div>

                <div>
                    <div className='inner-title'>{t('reports.total_amount')}</div>
                    <div className='value'>
                        <CurrencyValue currency={currency} notInCents>{generalDebt}</CurrencyValue>
                    </div>
                </div>
            </div>
        </InfoCardStyled>
    )
}

export default DebtCard;
